import { useMemo } from 'react';
import { usePreprocessedDict } from './use-preprocessed-dict';

export const useCoreWordDictionary = (coreWordDictionary, textNodes) => {
  const { trie } = coreWordDictionary ?? {};

  const preprocessedDict = useMemo(() => {
    let dict = new Map();

    if (!trie || !textNodes) {
      return dict;
    }

    let visitingNodes = [[trie, []]];

    eachChar(textNodes, ({ char, textNode, textOffset, charOffset }) => {
      const nextVisitingNodes = [[trie, []]];

      visitingNodes.forEach(([prevNode, textPath]) => {
        const [, trieMap] = prevNode;
        const trieNode = trieMap?.[char];

        if (trieNode) {
          const [coreWordIds] = trieNode;
          const nextTextPath = [...textPath, { textNode, textOffset, charOffset }];

          if (coreWordIds.length > 0) {
            nextTextPath.forEach(({ textNode, charOffset }) => {
              if (!dict.has(textNode)) {
                dict.set(textNode, []);
              }

              const results = coreWordIds.map((coreWordId) => ({
                textPath: nextTextPath,
                coreWordId,
              }));

              const textEntries = dict.get(textNode);
              textEntries[charOffset] = results.concat(textEntries[charOffset] ?? []);
            });
          }

          nextVisitingNodes.push([trieNode, nextTextPath]);
        }
      });

      visitingNodes = nextVisitingNodes;
    });

    return dict;
  }, [trie, textNodes]);

  return usePreprocessedDict(preprocessedDict, getWordIds);
};

const eachChar = (textNodes, callback) => {
  textNodes.forEach((textNode, textOffset) => {
    const text = textNode.textContent;

    for (let charOffset = 0; charOffset < text.length; charOffset++) {
      const char = text[charOffset];
      callback({ char, textNode, textOffset, charOffset });
    }
  });
};

const getWordIds = (results) => ({
  coreWordIds: results.map(({ coreWordId }) => coreWordId),
});
